import { SET_MACHINE_STATUS, SET_USERS_ONLINE } from './types';
import axios from 'axios';
import { getApiUrl } from '../util/getServerInfo';
import { debugLog, debugWarn } from '../util/debug';

/**
 * Fetch machine status (storage usage + recording days).
 * Backend method: info.getMachineStatus
 * Returns: [days, sTotal, sUsed, sPercent]
 */
export const fetchMachineStatus = (sSess) => {
    return async (dispatch) => {
        try {
            const response = await axios.post(getApiUrl(), {
                jsonrpc: 2.0,
                method: 'info.getMachineStatus',
                id: 300,
                params: [sSess]
            }, { timeout: 6000 });

            const result = response.data?.result?.[1];
            if (Array.isArray(result) && result.length >= 4) {
                const [days, sTotal, sUsed, sPercent] = result;
                debugLog('[StatusActions] Machine status:', { days, sTotal, sUsed, sPercent });
                dispatch({
                    type: SET_MACHINE_STATUS,
                    payload: { days, sTotal, sUsed, sPercent }
                });
            }
        } catch (error) {
            debugWarn('[StatusActions] fetchMachineStatus error:', error.message);
        }
    };
};

/**
 * Fetch users currently online.
 * Backend method: online.getUserList
 * Returns: array of username strings
 */
export const fetchUsersOnline = (sSess) => {
    return async (dispatch) => {
        try {
            const response = await axios.post(getApiUrl(), {
                jsonrpc: 2.0,
                method: 'online.getUserList',
                id: 301,
                params: [sSess]
            }, { timeout: 6000 });

            const result = response.data?.result?.[1];
            if (Array.isArray(result)) {
                debugLog('[StatusActions] Users online:', result);
                dispatch({
                    type: SET_USERS_ONLINE,
                    payload: result
                });
            }
        } catch (error) {
            debugWarn('[StatusActions] fetchUsersOnline error:', error.message);
        }
    };
};
